<template>
  <nav class="navigation">
    <div ref="navigation" class="navigation-tab">
      <router-link
        v-for="(item, i) in tabList"
        ref="link"
        :key="i"
        :to="{
          name: item.pathname,
          params : { ...localeParams, ...item.params },
          query: { ...item.query },
          hash: item.hash
        }"
        :class="{
          active: $route.name === item.pathname
        }"
        @click.native="onTabClick"
      >
        {{ $t(item.title) }}
      </router-link>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import menu from '@/mixins/menu'

export default {
  mixins: [
    menu
  ],
  props: {
    tabList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
    }),
    localeParams () {
      return {
        locale: this.locale === 'en' ? 'en' : undefined
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.$nextTick(this.goTabPage)
    },
    onTabClick (e) {
      this.goPageAnchor(e)

      setTimeout(this.goTabPage, 1)
    },
    goTabPage () {
      const currentTab = this.$refs.link.find(item => item.$el.classList.contains('active')).$el
      const gutter = Number(parseFloat(getComputedStyle(this.$refs.navigation).getPropertyValue('--gutter')))
      const offsetLeft = (currentTab.getBoundingClientRect().left - gutter) - ((this.$refs.navigation.clientWidth - gutter * 2) / 2 - this.$refs.navigation.scrollLeft) + (currentTab.offsetWidth / 2)

      this.$refs.navigation.scrollTo({
        left: offsetLeft,
        behavior: 'smooth'
      })
    }
  }
}
</script>
